var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.41 4.838a.75.75 0 0 1 0 1.492l-.076.004H6.477l5.387 5.387.05.056a.75.75 0 0 1-1.054 1.055l-.056-.05-5.387-5.387v4.856a.75.75 0 0 1-1.5 0V5.584q.002-.122.039-.231.007-.026.015-.051l.004-.01q.016-.031.033-.062a.8.8 0 0 1 .129-.176.7.7 0 0 1 .195-.138q.02-.012.043-.023l.01-.004q.025-.009.05-.016a.8.8 0 0 1 .232-.039h6.667z"
  })));
};
export default Svg16;